module.exports = __webpack_public_path__ + "static/media/015ty@3x.4e71bf80.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/015ty@3x.png
// module id = 1664
// module chunks = 0 1